var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 1.3335C4.31967 1.3335 1.33301 4.32016 1.33301 8.00016C1.33301 11.6802 4.31967 14.6668 7.99967 14.6668C11.6797 14.6668 14.6663 11.6802 14.6663 8.00016C14.6663 4.32016 11.6797 1.3335 7.99967 1.3335ZM2.66634 8.00016C2.66634 5.0535 5.05301 2.66683 7.99967 2.66683C9.23301 2.66683 10.3663 3.08683 11.2663 3.7935L3.79301 11.2668C3.08634 10.3668 2.66634 9.2335 2.66634 8.00016ZM7.99967 13.3335C6.76634 13.3335 5.63301 12.9135 4.73301 12.2068L12.2063 4.7335C12.913 5.6335 13.333 6.76683 13.333 8.00016C13.333 10.9468 10.9463 13.3335 7.99967 13.3335Z",
    fill: "#BB448B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stop_icon.02cc75169ab34ec856cf212e38b92b5c.svg";
export { ForwardRef as ReactComponent };